
import React from "react";
// @ts-ignore
import dfnLogo from "../../../../assets/DFN.svg";
import { DFNButton, DFNLoginButtonContainer, Logo } from "./DFNButton.styles";



const DFNLoginButton: React.FC = () => {
    const handleDFNLogin = () => {
        window.location.href =
            "https://satosa.divinagame.de/Saml2/OIDC/authorization?response_type=id_token&scope=openid%20persistent&client_id=divinagame&state=7CQuKalrMExhvV6Y_HWh2DQhMB4&redirect_uri=https%3A%2F%2Fdivinagame.de&nonce=JsWB8PC7FIX0QbGtI0y4avf9y5-7juJEHXK0tfn8Uhc&claims=%7B%22id_token%22:%7B%22institution%22:%22null%22,%22affiliation%22:%22null%22%7D%7D";
    };

    return (
        <DFNLoginButtonContainer>
            <DFNButton onClick={handleDFNLogin}>
                <Logo src={dfnLogo} alt="DFN Logo" />
                Sign in with DFN
            </DFNButton>
        </DFNLoginButtonContainer>
    );
};

export default DFNLoginButton;
